#cookies-container{position:fixed;bottom:0;width:100%;z-index:1001}
/*# sourceMappingURL=cookie-consent.component-BZAPAQBK.css.map */
